import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TestBackup } from 'src/app/models/test_backup_model';
import { IpvService } from 'src/app/services/ipv.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-ipv',
  templateUrl: './ipv.component.html',
  styles: [
  ]
})
export class IpvComponent implements OnInit {
  @ViewChild('instructions') instructions: ElementRef;
  
  public questions;
  public answers = [];
  public index;
  public selectedQuestion:any={
    "title":"",
    "opcA":{"text":""},
    "opcB":{"text":""},
    "opcC":{"text":""},
  };

  public score = {
    "DGV":0,
    "I":0,
    "II":0,
    "III":0,
    "IV":0,
    "V":0,
    "VI":0,
    "VII":0,
    "VIII":0,
    "IX":0,
    "A":0,
    "R":0,
   }

  public scoreConverted = {
    "DGV":0,
    "I":0,
    "II":0,
    "III":0,
    "IV":0,
    "V":0,
    "VI":0,
    "VII":0,
    "VIII":0,
    "IX":0,
    "A":0,
    "R":0,
  }

  public testData;
  public photoTaked = false;
  public trigger = false;

  public texts;

  constructor(private ipvService: IpvService, private testService:TestService, private router:Router) {
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
      },
      err=>console.log(err)
    )
    this.ipvService.getQuestions().subscribe(
      async resp=>{
        this.questions = resp;
        await this.checkBackup();

      },
      err=>{

      }
    )
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
   }

  ngOnInit(): void {
  }

    public backupTimer: any;
    public backup?: TestBackup;
  
    async checkBackup(){
      let backup = await this.testService.getTestBackups({testId: this.testService.selectedTestData._id}).toPromise()
      if (backup && backup.length > 0) {
        this.startBackupTimer()
        this.backup = backup[0];
        this.index = backup[0].data.index;
        this.score = backup[0].data.score || {};
        this.answers = backup[0].data.answers;
        this.selectedQuestion = this.questions[this.index]
        this.testService.testStarted = true;
        $("#myModal").modal("show");
        this.testService.testStarted = true;
        if (this.testData.camera){
          setTimeout(() => {
            this.trigger = !this.trigger;
          }, Math.floor(Math.random() * 60000 + 240000));
        }
        var testData = this.testService.selectedTestData;
        testData.isStarted = true;
        this.testService.updateTest(testData).subscribe();
      }
    }
  
    startBackupTimer(){
      this.backupTimer = setInterval(() => {
        if (this.testService.testStarted) {
          let data = {
            index: this.index,
            score: this.score,
            answers: this.answers,
          }
          let backup: TestBackup = {
            testId: this.testService.selectedTestData._id,
            userEmail: this.testService.selectedTestData.client,
            userName: this.testService.selectedTestData.evaluatedName,
            data: data
          }
          if (this.backup?._id){
            backup._id = this.backup._id;
          }
          this.testService.createTestBackup(backup).subscribe(
            res => {
              this.backup = res;
            },
            err => console.log(err)
          );
        }
      }, 15000); // Backup cada 15 segundos
    }
  
    ngOnDestroy(){
      if (this.backupTimer) {
        clearInterval(this.backupTimer);
      }
    }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.ipvInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

  startTest(){
    this.startBackupTimer()

    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    
    this.selectedQuestion = this.questions[0];
    this.index = 0;
    this.score = {
      "DGV":0,
      "I":0,
      "II":0,
      "III":0,
      "IV":0,
      "V":0,
      "VI":0,
      "VII":0,
      "VIII":0,
      "IX":0,
      "A":0,
      "R":0,
    };

    this.scoreConverted = {
      "DGV":0,
      "I":0,
      "II":0,
      "III":0,
      "IV":0,
      "V":0,
      "VI":0,
      "VII":0,
      "VIII":0,
      "IX":0,
      "A":0,
      "R":0,
    };

    this.answers = [];
    
  }

  nextQuestion(){

    this.index = this.index + 1;
    this.selectedQuestion = this.questions[this.index];
    //console.log(this.index);
    //console.log(this.selectedQuestion);
    if(!this.selectedQuestion){
      this.trigger = !this.trigger;
      this.selectedQuestion = {
        "title":"Test finalizado",
        "opcA":{"text":"--"},
        "opcB":{"text":"--"},
        "opcC":{"text":"--"},

      }

      this.score.R = this.score.I + this.score.II + this.score.III + this.score.IV;
      this.score.A = this.score.V + this.score.VI + this.score.VII + this.score.VIII;
      this.convertScore();
      Swal.fire({
        text:'Has concluido esta evaluación. Agradecemos tu participación',
        icon:'success',
        confirmButtonText:'Salir'
      });
      jQuery("#myModal").modal("hide");
      
      this.ipvService.createReport(this.score, this.scoreConverted, this.answers).subscribe(
        res=>{
          var testData = this.testService.selectedTestData;
          testData.isCompleted = true;
          testData.reportId = res._id;
          testData.completeDate = Date.now();
          this.testService.updateTest(testData).subscribe(
            r=>{
              console.log(r);
              this.router.navigateByUrl('dashboard/requestedTests');
            },
            e=>console.log(e)
          );
        },
        err=> console.log(err)
      )
      
    }
  }

  convertScore(){

    if (this.score.R>=0&&this.score.R<14) this.scoreConverted.R = 1;
    if (this.score.R==15) this.scoreConverted.R = 2;
    if (this.score.R>=16&&this.score.R<=17) this.scoreConverted.R = 3;
    if (this.score.R>=18&&this.score.R<=19) this.scoreConverted.R = 4;
    if (this.score.R==20) this.scoreConverted.R = 5;
    if (this.score.R>=21&&this.score.R<=22) this.scoreConverted.R = 6;
    if (this.score.R>=23&&this.score.R<=24) this.scoreConverted.R = 7;
    if (this.score.R>=25&&this.score.R<=26) this.scoreConverted.R = 8;
    if (this.score.R>=27&&this.score.R<=28) this.scoreConverted.R = 9;
    if (this.score.R>=29&&this.score.R<=141) this.scoreConverted.R = 10;

    if (this.score.A>=0&&this.score.A<7) this.scoreConverted.A = 1;
    if (this.score.A==8) this.scoreConverted.A = 2;
    if (this.score.A>=9&&this.score.A<=10) this.scoreConverted.A = 3;
    if (this.score.A>=11&&this.score.A<=12) this.scoreConverted.A = 4;
    if (this.score.A==13) this.scoreConverted.A = 5;
    if (this.score.A>=14&&this.score.A<=15) this.scoreConverted.A = 6;
    if (this.score.A==16) this.scoreConverted.A = 7;
    if (this.score.A>=17&&this.score.A<=18) this.scoreConverted.A = 8;
    if (this.score.A>=19&&this.score.A<=20) this.scoreConverted.A = 9;
    if (this.score.A>=21&&this.score.A<=38) this.scoreConverted.A = 10;

    if (this.score.DGV>=0&&this.score.DGV<=5) this.scoreConverted.DGV = 1;
    if (this.score.DGV==6) this.scoreConverted.DGV = 2;
    if (this.score.DGV>=7&&this.score.DGV<=8) this.scoreConverted.DGV = 3;
    if (this.score.DGV==9) this.scoreConverted.DGV = 4;
    if (this.score.DGV==10) this.scoreConverted.DGV = 5;
    if (this.score.DGV==11) this.scoreConverted.DGV = 6;
    if (this.score.DGV==12) this.scoreConverted.DGV = 7;
    if (this.score.DGV>=13&&this.score.DGV<=14) this.scoreConverted.DGV = 8;
    if (this.score.DGV==15) this.scoreConverted.DGV = 9;
    if (this.score.DGV>=16&&this.score.DGV<=21) this.scoreConverted.DGV = 10;

    if (this.score.I>=0&&this.score.I<=1) this.scoreConverted.I = 1;
    if (this.score.I==2) this.scoreConverted.I = 2;
    if (this.score.I==3) this.scoreConverted.I = 3;
    if (this.score.I==4) this.scoreConverted.I = 4;
    if (this.score.I==5) this.scoreConverted.I = 6;
    if (this.score.I==6) this.scoreConverted.I = 7;
    if (this.score.I==7) this.scoreConverted.I = 8;
    if (this.score.I==8) this.scoreConverted.I = 9;
    if (this.score.I>=9&&this.score.I<=11) this.scoreConverted.I = 10;

    if (this.score.II>=0&&this.score.II<=1) this.scoreConverted.II = 1;
    if (this.score.II==2) this.scoreConverted.II = 2;
    if (this.score.II==3) this.scoreConverted.II = 3;
    if (this.score.II==4) this.scoreConverted.II = 4;
    if (this.score.II==5) this.scoreConverted.II = 6;
    if (this.score.II==6) this.scoreConverted.II = 7;
    if (this.score.II==7) this.scoreConverted.II = 8;
    if (this.score.II==8) this.scoreConverted.II = 9;
    if (this.score.II>=9&&this.score.II<=11) this.scoreConverted.II = 10;

    if (this.score.III>=0&&this.score.III<=1) this.scoreConverted.III = 1;
    if (this.score.III==2) this.scoreConverted.III = 2;
    if (this.score.III==3) this.scoreConverted.III = 3;
    if (this.score.III==4) this.scoreConverted.III = 4;
    if (this.score.III==5) this.scoreConverted.III = 5;
    if (this.score.III==6) this.scoreConverted.III = 6;
    if (this.score.III==7) this.scoreConverted.III = 8;
    if (this.score.III==8) this.scoreConverted.III = 9;
    if (this.score.III>=9&&this.score.III<=11) this.scoreConverted.III = 10;

    if (this.score.IV>=0&&this.score.IV<=3) this.scoreConverted.IV = 1;
    if (this.score.IV==4) this.scoreConverted.IV = 2;
    if (this.score.IV==5) this.scoreConverted.IV = 4;
    if (this.score.IV==6) this.scoreConverted.IV = 5;
    if (this.score.IV==7) this.scoreConverted.IV = 7;
    if (this.score.IV==8) this.scoreConverted.IV = 9;
    
    if (this.score.V>=0&&this.score.V<=1) this.scoreConverted.V = 1;
    if (this.score.V==2) this.scoreConverted.V = 2;
    if (this.score.V==3) this.scoreConverted.V = 3;
    if (this.score.V==4) this.scoreConverted.V = 4;
    if (this.score.V==5) this.scoreConverted.V = 5;
    if (this.score.V==6) this.scoreConverted.V = 7;
    if (this.score.V==7) this.scoreConverted.V = 8;
    if (this.score.V==8) this.scoreConverted.V = 9;
    if (this.score.V>=9&&this.score.V<=11) this.scoreConverted.V = 10;

    if (this.score.VI==0) this.scoreConverted.VI = 1;
    if (this.score.VI==1) this.scoreConverted.VI = 2;
    if (this.score.VI==2) this.scoreConverted.VI = 3;
    if (this.score.VI==3) this.scoreConverted.VI = 4;
    if (this.score.VI==4) this.scoreConverted.VI = 6;
    if (this.score.VI==5) this.scoreConverted.VI = 7;
    if (this.score.VI==6) this.scoreConverted.VI = 8;
    if (this.score.VI>=7&&this.score.VI<=11) this.scoreConverted.VI = 10;

    if (this.score.VII==0) this.scoreConverted.VII = 1;
    if (this.score.VII==1) this.scoreConverted.VII = 2;
    if (this.score.VII==2) this.scoreConverted.VII = 4;
    if (this.score.VII==3) this.scoreConverted.VII = 5;
    if (this.score.VII==4) this.scoreConverted.VII = 7;
    if (this.score.VII==5) this.scoreConverted.VII = 8;
    if (this.score.VII>=6&&this.score.VII<=8) this.scoreConverted.VII = 10;

    if (this.score.VIII==0) this.scoreConverted.VIII = 2;
    if (this.score.VIII==1) this.scoreConverted.VIII = 4;
    if (this.score.VIII==2) this.scoreConverted.VIII = 6;
    if (this.score.VIII==3) this.scoreConverted.VIII = 8;
    if (this.score.VIII==4) this.scoreConverted.VIII = 9;
    if (this.score.VIII>=5&&this.score.VIII<=8) this.scoreConverted.VIII = 10;

    if (this.score.IX>=0&&this.score.IX<=1) this.scoreConverted.IX = 1;
    if (this.score.IX==2) this.scoreConverted.IX = 2;
    if (this.score.IX==3) this.scoreConverted.IX = 3;
    if (this.score.IX==4) this.scoreConverted.IX = 4;
    if (this.score.IX==5) this.scoreConverted.IX = 6;
    if (this.score.IX==6) this.scoreConverted.IX = 7;
    if (this.score.IX==7) this.scoreConverted.IX = 9;
    if (this.score.IX==8) this.scoreConverted.IX = 10;
    if (this.score.IX>=9&&this.score.IX<=11) this.scoreConverted.IX = 10;
    
  }

  select(opc){
    this.answers.push(opc);
    if (opc==='A'){
      for (let f in this.score){
        if (this.selectedQuestion.types.indexOf(String(f))>=0){

          this.score[f] = this.score[f]+this.selectedQuestion.opcA.value;
        }
      }
    }

    if (opc==='B'){
      for (let f in this.score){
        if (this.selectedQuestion.types.indexOf(String(f))>=0){
          this.score[f] = this.score[f]+this.selectedQuestion.opcB.value;
        }
      }
    }

    if (opc==='C'){
      for (let f in this.score){
        if (this.selectedQuestion.types.indexOf(String(f))>=0){
          this.score[f] = this.score[f]+this.selectedQuestion.opcC.value;
        }
      }
    }
    this.nextQuestion();
    
  }

  reload(){
    location.reload()
  }

}
